import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GoArrowLeft } from "react-icons/go";
import logo from "../../assets/images/logo.png"
import methodModel from '../../methods/methods';
import FormControl from '../../common/FormControl';
import ApiClient from '../../methods/api/apiClient';
import { toast } from 'react-toastify';
import PopUp from '../../common/PopUp';

export const Forgot = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('');
    const inValidEmail = methodModel.emailvalidation(email);
    const [submitted, setSubmitted] = useState(false)
    const role = methodModel.getPrams("role")
    const [popUp, setPopUp] = useState({ modal: false, title: "", message: "", buttonText: "", image: "" })

    useEffect(() => {
        if (sessionStorage.getItem("token")) {
            navigate("/Event");
        }
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmitted(true)
        if (!inValidEmail) return
        let url = "users/forgot/password"
        ApiClient.put(url, { email }).then((res) => {
            if (res.success) {
                setPopUp({ modal: true, title: "", image: "/assets/img/email_success.svg", message: "A password reset email has been successfully sent to your registered email address.", buttonText: "Ok", redirectUrl: `/signin${role ? `?role=${role}` : ""}` })
            }
        })
    }

    return (
        <div className="light">
            <section className="bg-gray-50 dark:bg-gray-900 min-h-screen">
                <div className="container mx-auto px-5">
                    <div className="flex flex-col items-center justify-center mx-auto lg:py-0 h-screen">
                        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                            <div className="ml-4 mt-4">
                                <div onClick={() => { navigate(-1) }}>
                                    <GoArrowLeft className="cursor-pointer" size={20} />
                                </div>
                            </div>
                            <div className="px-5 space-y-4 md:space-y-6 pb-5">
                                <Link to="/Event" className="flex items-center justify-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white w-fit mx-auto">
                                    <img className="h-8 rounded p-1 mr-2" src={logo} alt="logo" />
                                </Link>
                                <h2 className="text-center text-xl font-semibold tracking-tight text-gray-600 dark:text-gray-400">
                                    Forgot your password
                                </h2>
                                <form onSubmit={handleSubmit} className="items-center space-y-4 md:space-y-6">
                                    <div>
                                        <FormControl
                                            type="text"
                                            name="email"
                                            placeholder="Enter Email"
                                            autoComplete="one-time-code"
                                            value={email}
                                            onChange={(e) => setEmail(e)}
                                            required
                                        />
                                        {email && !inValidEmail && submitted && (
                                            <div className="d-block text-sm text-red-600">Please enter valid email</div>
                                        )}
                                    </div>
                                    <button type="submit" className={`w-full text-white bg-[#005AAB] font-medium rounded-full text-sm px-5 py-3 text-center hover:opacity-[90%]`}>
                                        Forgot Password
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <PopUp popUp={popUp} setPopUp={setPopUp} redirectUrl={popUp?.redirectUrl || ""} />
        </div>
    );
};
